export default {
  default: () => import("/builds/proverky/proverky.net/frontend/layouts/default.vue").then(m => m.default || m),
  error: () => import("/builds/proverky/proverky.net/frontend/layouts/error.vue").then(m => m.default || m),
  "server-error": () => import("/builds/proverky/proverky.net/frontend/layouts/server-error.vue").then(m => m.default || m),
  "unknown-error": () => import("/builds/proverky/proverky.net/frontend/layouts/unknown-error.vue").then(m => m.default || m)
}